module.exports = __webpack_public_path__ + "img/radio_on.852a5f4b.svg";